module.exports = __webpack_public_path__ + "img/br35.164b4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br35.jpg
// module id = tfIs
// module chunks = 0